export { default } from "./AssignmentAnchorItem";
